import { useState } from "react";
import { setYear } from "../../store/slices/paycheckSlice";
import { useDispatch, useSelector } from "react-redux";

import './TableFilter.scss';
import arrowIcon from '../../img/bottom-arrow.svg';

export default function TableFilter({className=""}) {
    const [isOpen, setIsOpen] = useState(false);
    const paycheckStore = useSelector(state => state.paycheck);
    const dispatch = useDispatch();

    const handleOpen = () => setIsOpen(!isOpen);

    const handleValue = (event) => {
        const el = event.target.localName;
        if (el === 'li') { 
            const year = event.target.textContent;
            dispatch(setYear(year));
            setIsOpen(false);
        }
    }

    return (
        <div className={`table-filter ${className} ${isOpen ? '_active' : ""}`}>
            <button className="btn table-filter__select" onClick={handleOpen}>
                <p>{paycheckStore.year}</p>
                <img src={arrowIcon} alt="arrow icon" />
            </button>
            { isOpen &&
                <ul className="table-filter__items" onClick={handleValue}>
                    <li className="table-filter__item">2022</li>
                    <li className="table-filter__item">2021</li>
                    <li className="table-filter__item">2020</li>
                    <li className="table-filter__item">2019</li>
                    <li className="table-filter__item">2018</li>
                    <li className="table-filter__item">2017</li>
                    <li className="table-filter__item">2016</li>
                    <li className="table-filter__item">2015</li>
                    <li className="table-filter__item">2014</li>
                    <li className="table-filter__item">2013</li>
                    <li className="table-filter__item">2012</li>
                </ul>
            }
        </div>
    );
}